<template>
    <BaseDialog :title="t('assessments.ratingGuide.title')" width="narrow">
        <template #trigger>
            <BaseButton theme="tertiary" size="sm" class="max-w-full whitespace-normal tracking-normal">
                <i class="bi bi-info-circle text-xs" aria-hidden="true"></i>
                {{ t("assessments.ratingGuide.trigger") }}
            </BaseButton>
        </template>
        <div class="divide-y divide-border">
            <div v-for="n in 5" :key="n" class="py-4 flex gap-4">
                <div class="shrink-0 w-8 h-8 rounded-full bg-surface-sunken text-ink body-small-bold flex items-center justify-center">
                    {{ n }}
                </div>
                <div>
                    <p class="body-small-bold text-ink">{{ ratingLabels[String(n)] }}</p>
                    <p class="details text-ink-muted mt-1">{{ ratingShortDescriptions[String(n)] }}</p>
                    <p class="details text-ink-muted mt-1">{{ ratingDescriptions[String(n)] }}</p>
                </div>
            </div>
            <div v-if="showNotApplicable" class="py-4 flex gap-4">
                <div class="shrink-0 w-8 h-8 rounded-full bg-surface-sunken text-ink-muted details flex items-center justify-center">
                    {{ t("assessments.ratingGuide.notApplicableBadge") }}
                </div>
                <div>
                    <p class="body-small-bold text-ink">{{ t("assessments.ratingGuide.notApplicableTitle") }}</p>
                    <p class="details text-ink-muted mt-1">{{ t("assessments.ratingGuide.notApplicableDescription") }}</p>
                </div>
            </div>
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

interface Props {
    ratingLabels: Record<string, string>;
    ratingShortDescriptions: Record<string, string>;
    ratingDescriptions: Record<string, string>;
    // The competency assessment's slider has a 0 = N/A position; Schneider's does not.
    showNotApplicable?: boolean;
}

withDefaults(defineProps<Props>(), {
    showNotApplicable: false,
});
</script>
